var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 502.37 502.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_3",
    "data-name": "Exclusion 3",
    d: "M255.82,506.85C117.1,506.86,4.64,394.42,4.63,255.7A251.18,251.18,0,0,1,78.21,78.07C176.3-20,335.34-20,433.43,78.07s98.09,257.13,0,355.23A249.52,249.52,0,0,1,255.82,506.85Zm71.76-394.69V381.27h71.76V112.16ZM219.94,291.57v89.7H291.7v-89.7ZM112.29,112.16V381.27h71.77V112.16Z",
    transform: "translate(-4.63 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMin);
export default __webpack_public_path__ + "static/media/iconMin.d2fbc7f63782cde9dd32627164939f23.svg";
export { ForwardRef as ReactComponent };